import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ISaveCommuterMileageSetting {
  daily_mileage_cap: number;
  mileage_exemption: 'both' | 'first' | 'last';
}

const saveCommuterMileageSetting = (postData: ISaveCommuterMileageSetting) => {
  return http().post(endpoints.companySettings.commuterMileageSettings, postData);
};

export function useSaveCommuterMileageSetting() {
  return useMutation({ mutationFn: saveCommuterMileageSetting });
}
